import './index.scss';
import React,
{useEffect, useRef, useState} from 'react';
import CloseIcon from 'assets/icons/x-close-mobile-icon.svg';
import ArrowIcon from 'assets/icons/arrow-left-blue.svg';
import PersonalDetails from 'assets/icons/personal-details.svg';
import GoogleBadge from 'assets/icons/google-badge.png';
import AppleBadge from 'assets/icons/apple-badge.png';
import * as Routes from 'constants/routes';
import * as Popups from 'constants/popup-types';
import {NavLink, useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {addPopup, logout, setDrawerSubMenu} from 'redux/actions';
import AnalyticsManager from 'app/analytics';
import {getMediaPath, sortArrayByKey} from 'app/functions';
import BurgerRow from './components/burger-row';
import SubMenu from './components/sub-menu';

const MobileMenu = (props) => {
    const {onClose, pathname, open} = props;
    const footerLinks = useSelector(store => store.config.FooterLinks);
    const userData = useSelector(store => store.config.UserData);
    const texts = useSelector(store => store.config.Translations);
    const megaMenu = useSelector(store => store.config.megaMenu);
    const subMenu = useSelector(store => store.state.drawerSubMenu);
    const dispatch = useDispatch();
    const history = useHistory();
    const backdropRef = useRef();
    const [originalPath, setOriginalPath] = useState(pathname);

    useEffect(() => {
        if (originalPath !== pathname) {
            setOriginalPath(originalPath);
            dispatch(setDrawerSubMenu(null));
            onClose();
        }
    }, [pathname])

    useEffect(() => {
        document.addEventListener('click', closeSubMenus);

        return () => {
            document.removeEventListener('click', closeSubMenus);
        }
    }, [])

    const closeSubMenus = (e) => {
        if (e.target === backdropRef.current) {
            dispatch(setDrawerSubMenu(null));
        }
    }

    const handleLogout = () => {
        AnalyticsManager.logLogout();
        dispatch(logout());
    }

    const handleLogin = () => {
        onClose();
        dispatch(addPopup({
            type: Popups.LOGIN
        }))
    }

    const setSubMenu = (id, title) => {
        if (subMenu?.id === id) {
            dispatch(setDrawerSubMenu(null));
        } else {
            dispatch(setDrawerSubMenu({
                id: id,
                title: "תפריט ראשי",
                subtitle: title
            }));
        }
    }

    const handleIconOnClick = (title) => {
        AnalyticsManager.logMenuItemPress(title);

        const socialMedia = footerLinks.social_media_links;
        const appStores = footerLinks.app_store_links;

        for (let key in socialMedia) {
            if (socialMedia[key].title === title) {
                AnalyticsManager.logSocialMediaLinkPress(title);
                window.open(socialMedia[key].link.route, '_blank', 'noopener');
            }
        }

        for (let key in appStores) {
            if (appStores[key].title === title) {
                AnalyticsManager.logAppStoreLinkPress(title);
                window.open(appStores[key].link.route, '_blank', 'noopener');
            }
        }
    }

    const openClassName = open ? "open" : "";
    return (
        <div className={`mobile-menu-wrapper ${openClassName}`}>
            <div className={`burger-backdrop ${openClassName}`} onClick={onClose} ref={backdropRef}/>
            <div className={`overlay-wrapper ${openClassName}`}>
                <div className={`burger-overlay ${openClassName}`}>
                    <BurgerRow>
                        <div className="right-side">
                            <div className="icon-wrapper">
                                <img src={getMediaPath(PersonalDetails)} alt="/" className="icon"/>
                            </div>
                            <span className='title fix-space' onClick={userData ? () => {
                            } : handleLogin}>{userData ? `היי, ${userData['first_name']}` : texts['header_personal_zone']}</span>
                        </div>
                        <div className="left-side">
                            {userData && <NavLink to={Routes.user_info} className="link">
                                {texts['mobile_menu_personal_zone']}
                            </NavLink>}
                            <button className="row-icon-wrapper" onClick={onClose}>
                                <img src={getMediaPath(CloseIcon)} alt="/" className="icon"/>
                            </button>
                        </div>
                    </BurgerRow>
                    <BurgerRow id={0} text={texts['mega_menu_shopping_categories']} icon={ArrowIcon}
                               onClick={setSubMenu}/>
                    <BurgerRow id={1} text={texts['mega_menu_smart_consumption']} icon={ArrowIcon}
                               onClick={setSubMenu}/>
                    {sortArrayByKey(Object.values(megaMenu['links'])).map((linkData) => (
                        <BurgerRow
                            key={`burger-row_${linkData.id}`}
                            text={linkData.title}
                            onClick={() => {
                                AnalyticsManager.logMenuItemPress(linkData.title);
                                if (linkData.link) {
                                    if (linkData.link.type === 'external') {
                                        if (linkData.link.route.startsWith(window.location.origin))
                                            window.location = linkData.link.route
                                        else window.open(linkData.link.route);
                                    } else {
                                        history.push(Routes[linkData.link.route]);
                                    }
                                }
                            }}
                        />
                    ))}
                    <BurgerRow id={2} text={texts['mega_menu_actions']} icon={ArrowIcon} onClick={setSubMenu}/>
                    <BurgerRow>
                        <div className="right-side">
                        <span className='title bold'>
                            {texts['mobile_menu_download_app']}
                        </span>
                        </div>
                        <div className="left-side">
                            <button className="app-download" onClick={handleIconOnClick.bind(this, 'App Store')}>
                                <img src={getMediaPath(AppleBadge)} alt="/" className="icon"/>
                            </button>
                            <button className="app-download google"
                                    onClick={handleIconOnClick.bind(this, 'Google Play')}>
                                <img src={getMediaPath(GoogleBadge)} alt="/" className="icon"/>
                            </button>
                        </div>
                    </BurgerRow>
                    {userData && (
                        <div className="burger-row no-border">
                            <div className="right-side">
                                <div
                                    className='title link'
                                    onClick={handleLogout}
                                >
                                    {texts['mobile_menu_logout_button']}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <SubMenu sub={subMenu} onClose={setSubMenu}/>
            </div>
        </div>);
}

export default MobileMenu;
